import { useActor } from '@xstate/react';
import React from 'react';
import { useEditCaseContext } from '../../context/EditCaseContext';
import CaseForm from '../case/CaseForm';
import { IonButton } from '@ionic/react';

interface EnterInfoProps {}

const EnterInfo: React.FC<EnterInfoProps> = (props) => {
  const { editCaseService } = useEditCaseContext();
  const [state, send] = useActor(editCaseService);

  return (
    <CaseForm
      case={state.context.caseInfo}
      initialValues={state.context.caseInfo}
      title="Edit case"
      onSubmit={async (values) => {
        send({ type: 'NEXT', caseInfo: values });
      }}
      renderButtons={({ disabled }) => (
        <>
          <IonButton
            fill="clear"
            type="button"
            onClick={() => send({ type: 'BACK' })}
          >
            Back
          </IonButton>
          <IonButton type="submit" disabled={disabled}>
            Payment
          </IonButton>
        </>
      )}
    />
  );
};

export default EnterInfo;
